import styled, { css } from 'styled-components';
import { Button, Drawer } from 'antd';

export const DrawerWrapper = styled(Drawer)`
	.ant-drawer-header {
		padding: 16px 24px;
		border-bottom: 1px solid ${({ theme }) => theme.palette.secondary['50']};
	}

	.ant-drawer-body {
		padding: 24px;
		display: flex;
		flex-direction: column;
		height: 100%;
	}

	.ant-drawer-title div {
		font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
		font-weight: 500;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.close-icon {
		font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
		cursor: pointer;
		transition: color 0.3s;

		&:hover {
			color: #2f54eb;
		}
	}
`;

const baseButton = css`
	border-radius: 4px;
	font-weight: 400;
	font-size: 16px;
	height: 40px;
`;

export const PrimaryButton = styled(Button)`
	${baseButton}
	background-color: #2f54eb;
	color: #fff;
`;

export const OutlinedlButton = styled(Button)`
	${baseButton}
`;
